const galleryTypes = [
  "step1-1",
  "step1-2",
  "step2-1",
  "step3-1",
  "step4-1",
  "step4-2",
];

let gallery_styles = ``;

galleryTypes.forEach((gallery_type_key) => {
  let image_div, gallery_container, height, nextCls, containerBottom;
  image_div = `image_div-${gallery_type_key}`;
  gallery_container = `image-gallery-${gallery_type_key}`;
  height = "537px";
  nextCls = ".next_btn";
  containerBottom = "50px";
  if (gallery_type_key === "step4-1" || gallery_type_key === "step4-2") {
    height = "450px";
    containerBottom = "10px";
  }

  const gallery_type_style = `#${gallery_container} {
    width: 100%;
    position: relative;
    height: ${height};
    background: #fdfdfd;
  }
  
  #${gallery_container} .image-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: ${containerBottom};
  }
  
  #${gallery_container} .prev_btn,
  #${gallery_container} ${nextCls} {
    position: absolute;
    height: 32px;
    margin-top: -66px;
    top: 50%;
  }
  
  #${gallery_container} .prev_btn {
    left: 20px;
    cursor: pointer;
  }
  
  #${gallery_container} ${nextCls} {
    right: 20px;
    cursor: pointer;
  }
  
  #${gallery_container} .footer-info {
    position: absolute;
    height: 50px;
    width: 100%;
    left: 0;
    bottom: 0;
    line-height: 50px;
    font-size: 24px;
    text-align: center;
    color: white;
    border-top: 1px solid #fff;
  }
  
  #${gallery_container} .${image_div} {
    border: solid 1px #d5d5d5;
    overflow: hidden;
    position: absolute;
    height: 100%;
    width: 100%;
    background: #fdfdfd;
  }
  
  #${gallery_container} .image_tag {
    position: absolute;
    z-index: 0;
  }
  
  #${gallery_container} .image_wrap {
    height: 100%;
  }
  
  #${gallery_container} .pdf_tag {
    height: 93%;
  }
  
  #${gallery_container} .pdfviewer {
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  
  #${gallery_container} .pdfviewer .loader {
    position: unset;
  }
  
  #${gallery_container} .pdfviewer-container {
    margin: 0;
    padding: 0;
    display: flex;
    overflow: hidden;
    flex: 1;
  }
  
  #${gallery_container} .pdfjs-viewer {
    border: 1px solid rgb(71, 71, 71);
    background: rgb(71, 71, 71);
  }
  
  #${gallery_container} .thumbnails {
    width: 150px !important;
    border: 1px solid rgb(71, 71, 71);
    border-right: 3px solid rgb(71, 71, 71);
    background: rgb(71, 71, 71);
  }
  
  #${gallery_container} .thumbnails .pdfpage.selected {
    border: 2px solid black;
    border-radius: 2px;
  }
  
  #${gallery_container} .maindoc {
    flex: 1;
    width: 100%;
  }
  
  #${gallery_container} .hide {
    display: none;
  }
  
  #${gallery_container} input[type="file"] {
    display: none;
  }
  
  #${gallery_container} .pdftoolbar button {
    background: rgb(71, 71, 71);
  }
  
  #${gallery_container} .pdftoolbar {
    background-color: rgb(71, 71, 71);
    justify-content: space-between;
    border-bottom: solid 2px #595858;
  }
  
  #${gallery_container} .pdf_sidebar {
    background-color: rgb(71, 71, 71) !important;
  }
  
  #${gallery_container} .pdftoolbar button i {
    font-size: 21px;
    color: lightgray;
  }
  
  #${gallery_container} .pdftoolbar button:hover {
    background-color: rgb(71, 71, 71) !important;
  }
  
  #${gallery_container} button.pushed {
    background-color: rgb(71, 71, 71) !important;
  }
  
  #${gallery_container} .zoomval {
    background-color: white;
    padding: 6px;
  }
  `;

  gallery_styles += gallery_type_style;
});

gallery_styles += ` .galyBox {
    position: relative;
  }
  
  .zoom-sprite {
    background: rgba(0, 0, 0, 0.72)
      url("${process.env.REACT_APP_STYLES_PATH}zoom-sprite.png")
      no-repeat 0px 0px;
    display: inline-block;
    border: none;
  }
  .ic-zoom-out {
    width: 24px;
    height: 24px;
    background-position: -177px 0px;
  }
  .galyBox select {
    border: solid 1px #666;
    padding: 3px;
    margin-bottom: 8px;
    width: 100%;
  }
  .action-buttons {
    position: absolute;
    top: 48px;
    right: 8px;
    z-index: 4;
  }
  .action-buttons button {
    margin-left: 4px;
  }
  .ic-rotate {
    width: 24px;
    height: 24px;
    background-position: -118px 0px;
  }
  .ic-fullscreen {
    width: 24px;
    height: 24px;
    background-position: -90px 0px;
  }
  .ic-zoom-in {
    width: 24px;
    height: 24px;
    background-position: -150px 0px;
  }
  .ic-zoom-edit {
    width: 24px;
    height: 24px;
    background-position: -178px -30px;
  }
  .ic-mousewheel {
    width: 30px;
    height: 49px;
    background-position: -56px 0px;
  }
  .iv-image-view {
    border: solid 1px #d5d5d5;
    overflow: hidden;
  }
  .ic-next {
    width: 36px;
    height: 36px;
    background-position: -94px -23px;
    border-radius: 50%;
  }
  .ic-prev {
    width: 36px;
    height: 36px;
    background-position: -134px -23px;
    border-radius: 50%;
  }
  .zoom_edit {
    position: absolute;
    top: 41px;
    right: 16px;
  }
  
  .react-transform-component, .react-transform-wrapper{
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  .react-transform-component{
    display: flex;
    align-items: center;
  }`;

export { gallery_styles };
